// Are we rendering on the server or are we in the browser?
export function isBrowser() {
  return typeof document !== 'undefined';
}

export function isServiceWorker() {
  return !isBrowser() && typeof navigator !== 'undefined' && cachesObjectExistsAndIsCacheStorage();
}

function cachesObjectExistsAndIsCacheStorage() {
  // https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage
  return typeof caches !== 'undefined' && caches.delete && caches.has && caches.keys && caches.match && caches.open;
}

export function isTouch() {
  // Detection explained: https://hacks.mozilla.org/2013/04/detecting-touch-its-the-why-not-the-how/
  return (isBrowser() && 'ontouchstart' in window) || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

let isCurrentScrollBar: boolean;
export function isScrollBar() {
  return isCurrentScrollBar || (isCurrentScrollBar = isBrowser() && window.innerWidth > document.body.offsetWidth);
}

export function iOSVersion() {
  if (!isIOS()) {
    throw new Error('Can not get iOS version on a none iOS device');
  }
  const versionString = navigator.userAgent.match(/\sOS ([0-9]+_[0-9]+)/);
  if (!versionString) {
    return 0; // We don't know
  }
  return parseFloat(versionString[1].replace('_', '.'));
}

export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

export function isLandscape() {
  return isBrowser() && window.screen.width > window.screen.height;
}

export function isPortrait() {
  return isBrowser() && !isLandscape();
}

export function isIE() {
  return /MSIE|Trident/.test(navigator.userAgent);
}

export function isEdge() {
  return /Edge/.test(navigator.userAgent);
}

export function isFF() {
  return /Firefox/.test(navigator.userAgent);
}

export function isSF() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

export function externalSvgUseSupported() {
  return !isIE() && !/Edge\/12/.test(navigator.userAgent);
}

export const supportAsyncStorage = (() => {
  if (!isBrowser() && !isServiceWorker()) {
    return false;
  }
  if (isServiceWorker()) {
    return true;
  }

  return !!window.indexedDB;
})();
